import Cookies from 'js-cookie'
import { Api } from '@/api'

const state = {
  extensionVersion: '', // 当前安装插件的版本号，用于检测是否已安装插件、是否需要更新
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  buttonListMap: {},
  permission: [],
  // menuList: [],
  menuList: [
    {
      id: 'menu-0',
      path: '/',
      name: null,
      always: null,
      component: 'src/layout/index.vue',
      hidden: false,
      redirect: '/home',
      parentId: '',
      children: [
        {
          id: 'menu-1',
          path: '/home',
          component: 'src/views/home/index.vue',
          name: 'home',
          always: null,
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          meta: {
            activeMenu: null,
            title: '总览',
            menuType: 0,
            icon: 'iconfont icon-zonglan18'
          }
        },
        {
          id: 'menu-2',
          path: '/candidateManagement',
          component: 'src/views/candidateManagement/index.vue',
          name: 'candidateManagement',
          always: null,
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          meta: {
            activeMenu: null,
            title: '候选人管理',
            menuType: 0,
            icon: 'iconfont icon-houxuanrenguanli18'
          }
        },
        {
          id: 'menu-5',
          path: '/positionManagement',
          component: 'src/views/positionManagement/parent.vue',
          name: 'positionManagement',
          always: null,
          hidden: false,
          redirect: '/positionManagement/managementList',
          parentId: 'menu-0',
          meta: {
            activeMenu: null,
            title: '职位管理',
            menuType: 0,
            icon: 'iconfont icon-zhiweiguanli18'
          },
          children: [
            {
              id: 'menu-5-1',
              path: '/positionManagement/managementList',
              name: 'managementList',
              always: null,
              component: 'src/views/positionManagement/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-5',
              meta: {
                activeMenu: null,
                title: '',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-5-2',
              path: '/positionManagement/createPosition',
              name: 'createPosition',
              always: null,
              component: 'src/views/positionManagement/createPosition.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-5',
              meta: {
                activeMenu: null,
                title: '新建职位',
                menuType: 0,
                icon: ''
              }
            }
          ]
        },
        {
          id: 'menu-5-2',
          path: '/positionManagement/publishPosition',
          name: 'publishPosition',
          always: null,
          component: 'src/views/positionManagement/publishPosition.vue',
          hidden: false,
          redirect: null,
          parentId: 'menu-5',
          meta: {
            activeMenu: null,
            title: '发布职位',
            menuType: 0,
            icon: ''
          }
        },
        {
          id: 'menu-3',
          path: '/talentPool',
          component: 'src/views/talentPool/index.vue',
          name: 'talentPool',
          always: null,
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          meta: {
            activeMenu: null,
            title: '人才库',
            menuType: 0,
            icon: 'iconfont icon-rencaiku18'
          }
        },
        {
          id: 'menu-4',
          path: '/globalSearch',
          component: 'src/views/globalSearch/index.vue',
          name: 'globalSearch',
          always: null,
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          meta: {
            activeMenu: null,
            title: '全局搜索',
            menuType: 0,
            icon: 'iconfont icon-zonglan18'
          }
        },
        {
          id: 'menu-17',
          path: '/resumeFilter',
          name: 'resumeFilter',
          always: null,
          component: 'src/views/resumeFilter/index.vue',
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '简历筛选',
            menuType: 0,
            icon: 'iconfont icon-jianlishaixuan20'
          }
        },
        {
          id: 'menu-18',
          path: '/myInterview',
          name: 'myInterview',
          always: null,
          component: 'src/views/myInterview/index.vue',
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '我的面试',
            menuType: 0,
            icon: 'iconfont icon-wodimianshi18'
          }
        },
        {
          id: 'menu-16',
          path: '/waitAssign',
          name: 'waitAssign',
          always: null,
          component: 'src/views/waitAssign/index.vue',
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '待分配简历',
            menuType: 0,
            icon: 'iconfont icon-daifenpeijianli18'
          }
        },
        {
          id: 'menu-6',
          path: '/beFollowUp',
          component: 'src/views/beFollowUp/index.vue',
          name: 'beFollowUp',
          always: null,
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          meta: {
            activeMenu: null,
            title: '重点人才池',
            menuType: 0,
            icon: 'iconfont icon-daigenjin20'
          }
        },
        {
          id: 'menu-13',
          path: '/messageCenter',
          name: 'messageCenter',
          always: null,
          component: 'src/views/messageCenter/index.vue',
          hidden: false,
          redirect: '/messageCenter/todoList',
          parentId: 'menu-0',
          children: [
            {
              id: 'menu-13-1',
              path: '/messageCenter/todoList',
              name: 'messageCenter',
              always: null,
              component: 'src/views/messageCenter/todoList.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-13',
              meta: {
                activeMenu: null,
                title: '待办中心',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-13-2',
              path: '/messageCenter/notifyList',
              name: 'notifyList',
              always: null,
              component: 'src/views/messageCenter/notifyList.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-13',
              meta: {
                activeMenu: null,
                title: '通知中心',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-13-3',
              path: '/messageCenter/announceList',
              name: 'poster',
              always: null,
              component: 'src/views/messageCenter/announceList.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-13',
              meta: {
                activeMenu: null,
                title: '公告中心',
                menuType: 0,
                icon: ''
              }
            }
          ],
          meta: {
            activeMenu: null,
            title: '消息中心',
            menuType: 0,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-11',
          path: '/costPlatform',
          name: 'costPlatform',
          always: null,
          component: 'src/views/costPlatform/index.vue',
          hidden: false,
          redirect: '/costPlatform/gateway',
          parentId: 'menu-0',
          children: [
            {
              id: 'menu-11-1',
              path: '/costPlatform/gateway',
              name: 'gateway',
              always: null,
              component: 'src/views/costPlatform/gateway/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '门户设置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-2',
              path: '/costPlatform/authentication',
              name: 'authentication',
              always: null,
              component: 'src/views/costPlatform/authentication/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '认证设置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-3',
              path: '/costPlatform/poster',
              name: 'poster',
              always: null,
              component: 'src/views/costPlatform/poster/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '海报设置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-4',
              path: '/costPlatform/posterSeting',
              name: 'posterSeting',
              always: null,
              component: 'src/views/costPlatform/poster/posterSeting.vue',
              hidden: true,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '海报设置',
                menuType: 'menu',
                icon: ''
              }
            },
            {
              id: 'menu-11-5',
              path: '/costPlatform/reward',
              name: 'reward',
              always: null,
              component: 'src/views/costPlatform/reward/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '奖励设置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-6',
              path: '/costPlatform/recommended',
              name: 'recommended',
              always: null,
              component: 'src/views/costPlatform/recommended/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '推荐设置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-7',
              path: '/costPlatform/candidate',
              name: 'candidate',
              always: null,
              component: 'src/views/costPlatform/candidate/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '候选人&奖励管理',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-8',
              path: '/costPlatform/recommendedDetail',
              name: 'recommendedDetail',
              always: null,
              component: 'src/views/costPlatform/recommendedDetail/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '推荐明细',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-11-9',
              path: '/costPlatform/activityManager',
              name: 'activityManager',
              always: null,
              component: 'src/views/costPlatform/activityManager/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-11',
              meta: {
                activeMenu: null,
                title: '活动管理',
                menuType: 0,
                icon: ''
              }
            }
          ],
          meta: {
            activeMenu: null,
            title: '运营平台',
            menuType: 0,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-12',
          path: '/setting',
          name: 'setting',
          always: null,
          component: 'src/views/setting/index.vue',
          hidden: false,
          redirect: '/setting/personalSettings',
          parentId: 'menu-0',
          children: [
            {
              id: 'menu-12-1',
              path: '/setting/personalSettings',
              name: 'personalSettings',
              always: null,
              component: 'src/views/setting/personalSettings/index.vue',
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              meta: {
                activeMenu: null,
                title: '个人设置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-2',
              path: '/setting/companyManagement',
              component: 'src/views/setting/companyManagement/index.vue',
              name: 'companyManagement',
              always: true,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-2-1',
                  path: '/setting/companyManagement/companyInfo',
                  component: 'src/views/setting/companyManagement/companyInfo.vue',
                  name: 'companyInfo',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-2',
                  meta: {
                    activeMenu: null,
                    title: '公司信息',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-2-2',
                  path: '/setting/companyManagement/companyAddress',
                  component: 'src/views/setting/companyManagement/companyAddress.vue',
                  name: 'companyAddress',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-2',
                  meta: {
                    activeMenu: null,
                    title: '公司地址',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-2-3',
                  path: '/setting/companyManagement/acceptResumeEmail',
                  component: 'src/views/setting/companyManagement/acceptResumeEmail.vue',
                  name: 'acceptResumeEmail',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-2',
                  meta: {
                    activeMenu: null,
                    title: '接收简历邮箱',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '公司信息管理',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-3',
              path: '/setting/organization',
              name: 'organization',
              component: 'src/views/setting/organization/index.vue',
              redirect: '/setting/organization/rolesIndex',
              always: true,
              hidden: false,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-3-1',
                  path: '/setting/organization/roles',
                  name: 'roles',
                  component: 'src/views/setting/organization/index.vue',
                  redirect: '/setting/organization/rolesIndex',
                  always: true,
                  hidden: false,
                  parentId: 'menu-12-3',
                  children: [
                    {
                      id: 'menu-12-3-1-1',
                      path: '/setting/organization/rolesIndex',
                      component: 'src/views/setting/organization/roles/index.vue',
                      name: 'rolesIndex',
                      always: null,
                      hidden: true,
                      redirect: null,
                      parentId: 'menu-12-3-1',
                      meta: {
                        activeMenu: null,
                        title: '角色管理',
                        menuType: 0,
                        breadcrumb: false,
                        icon: ''
                      }
                    },
                    {
                      id: 'menu-12-3-1-2',
                      path: '/setting/organization/functional',
                      component: 'src/views/setting/organization/roles/functional.vue',
                      name: 'functional',
                      always: null,
                      hidden: true,
                      redirect: null,
                      parentId: 'menu-12-3-1',
                      meta: {
                        activeMenu: null,
                        title: '功能权限',
                        menuType: 0,
                        breadcrumb: true,
                        icon: ''
                      }
                    },
                    {
                      id: 'menu-12-3-1-3',
                      path: '/setting/organization/dataPermission',
                      component: 'src/views/setting/organization/roles/dataPermission.vue',
                      name: 'dataPermission',
                      always: null,
                      hidden: true,
                      redirect: null,
                      parentId: 'menu-12-3-1',
                      meta: {
                        activeMenu: null,
                        title: '数据权限',
                        menuType: 0,
                        breadcrumb: true,
                        icon: ''
                      }
                    }
                  ],
                  meta: {
                    activeMenu: null,
                    title: '角色管理',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-3-2',
                  path: '/setting/organization/users',
                  name: 'users',
                  component: 'src/views/setting/organization/index.vue',
                  redirect: '/setting/organization/usersIndex',
                  always: true,
                  hidden: false,
                  parentId: 'menu-12',
                  children: [
                    {
                      id: 'menu-12-3-2-1',
                      path: '/setting/organization/usersIndex',
                      component: 'src/views/setting/organization/users/index.vue',
                      name: 'usersIndex',
                      always: null,
                      hidden: true,
                      redirect: null,
                      parentId: 'menu-12-3-2',
                      meta: {
                        activeMenu: null,
                        title: '用户管理',
                        menuType: 0,
                        breadcrumb: false,
                        icon: ''
                      }
                    }
                  ],
                  meta: {
                    activeMenu: null,
                    title: '用户管理',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-3-3',
                  path: '/setting/organization/orgManage',
                  name: 'orgManage',
                  component: 'src/views/setting/organization/index.vue',
                  redirect: '/setting/organization/orgManageIndex',
                  always: true,
                  hidden: false,
                  parentId: 'menu-12-3',
                  children: [
                    {
                      id: 'menu-12-3-3-1',
                      path: '/setting/organization/orgManageIndex',
                      component: 'src/views/setting/organization/orgManagement/index.vue',
                      name: 'orgManageIndex',
                      always: null,
                      hidden: true,
                      redirect: null,
                      parentId: 'menu-12-3-3',
                      meta: {
                        activeMenu: null,
                        title: '组织管理',
                        menuType: 0,
                        breadcrumb: false,
                        icon: ''
                      }
                    }
                  ],
                  meta: {
                    activeMenu: null,
                    title: '组织管理',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '组织机构管理',
                menuType: 0,
                breadcrumb: false,
                icon: ''
              }
            },
            {
              id: 'menu-12-4',
              path: '/setting/dataDictionary/index',
              component: 'src/views/setting/dataDictionary/index.vue',
              name: 'dataDictionary',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              meta: {
                activeMenu: null,
                title: '数据字典',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-5',
              path: '/setting/objectManage/index',
              component: 'src/views/setting/objectManage/index.vue',
              name: 'objectManage',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              meta: {
                activeMenu: null,
                title: '对象管理',
                menuType: 0,
                icon: null
              }
            },
            {
              id: 'menu-12-5-1',
              path: '/setting/objectManage/objectEdit',
              component: 'src/views/setting/objectManage/objectEdit/index.vue',
              name: 'objectEdit',
              always: null,
              children: [],
              hidden: true,
              redirect: null,
              permissionId: null,
              permissionCode: null,
              parentId: 'menu-12',
              meta: {
                activeMenu: null,
                title: '对象管理编辑',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-6',
              path: '/setting/evaluationSystem/index',
              component: 'src/views/setting/evaluationSystem/index.vue',
              name: 'evaluationSystem',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [],
              meta: {
                activeMenu: null,
                title: '评价/打分表设置',
                menuType: 0,
                icon: null
              }
            },
            {
              id: 'menu-12-7',
              path: '/setting/messageTemplate/index',
              component: 'src/views/setting/messageTemplate/index.vue',
              name: 'messageTemplate',
              redirect: '/setting/messageTemplate/list',
              always: false,
              hidden: false,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-7-1',
                  path: '/setting/messageTemplate/list',
                  component: 'src/views/setting/messageTemplate/list.vue',
                  name: 'messageTemplateList',
                  always: null,
                  hidden: true,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: null,
                  meta: {
                    activeMenu: null,
                    title: '消息模板',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-7-2',
                  path: '/setting/messageTemplate/templateDetail',
                  component: 'src/views/setting/messageTemplate/templateDetail.vue',
                  name: 'templateDetail',
                  always: null,
                  hidden: true,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: null,
                  meta: {
                    activeMenu: null,
                    title: '模板详情',
                    menuType: 0,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '消息模板',
                menuType: 0,
                breadcrumb: false,
                icon: null
              }
            },
            {
              id: 'menu-12-8',
              path: '/setting/autoSetting',
              component: 'src/views/setting/autoSetting/index.vue',
              name: 'autoSetting',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-8-1',
                  path: '/setting/autoSetting/autoFunctionSetting',
                  component: 'src/views/setting/autoSetting/page/autoFunctionSetting.vue',
                  name: 'autoFunctionSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '自动化功能设置',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-8-2',
                  path: '/setting/autoSetting/virtualPositionSetting',
                  component: 'src/views/setting/autoSetting/page/virtualPositionSetting/index.vue',
                  name: 'virtualPositionSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '虚拟职位分配规则',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-8-3',
                  path: '/setting/autoSetting/virtualPositionEdit',
                  component: 'src/views/setting/autoSetting/page/virtualPositionSetting/edit.vue',
                  name: 'virtualPositionEdit',
                  always: null,
                  hidden: true,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '虚拟职位分配规则编辑',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-8-4',
                  path: '/setting/autoSetting/candidateLockingSetting',
                  component: 'src/views/setting/autoSetting/page/candidateLockingSetting.vue',
                  name: 'candidateLockingSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '候选人锁定规则设置',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-8-5',
                  path: '/setting/autoSetting/emailFileRules',
                  component: 'src/views/setting/autoSetting/page/emailFileRules/index.vue',
                  name: 'emailFileRules',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '邮件归档规则',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-8-6',
                  path: '/setting/autoSetting/autoEventFlow',
                  component: 'src/views/setting/autoSetting/page/autoEventFlow/index.vue',
                  name: 'autoEventFlow',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '自动事件流程',
                    menuType: 0,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-8-7',
                  path: '/setting/autoSetting/autoEventFlowEdit',
                  component: 'src/views/setting/autoSetting/page/autoEventFlow/edit.vue',
                  name: 'autoEventFlowEdit',
                  always: null,
                  hidden: true,
                  redirect: null,
                  parentId: 'menu-12-8',
                  meta: {
                    activeMenu: null,
                    title: '自动事件流程编辑',
                    menuType: 0,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '自动化设置',
                menuType: 0,
                icon: null
              }
            },
            {
              id: 'menu-12-9',
              path: '/setting/recruitFlowManage',
              component: 'src/views/setting/recruitFlowManage/index.vue',
              name: 'recruitFlowManage',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-9-1',
                  path: '/setting/recruitFlowManage/recruitFlowSetting',
                  component: 'src/views/setting/recruitFlowManage/recruitFlowSetting/index.vue',
                  name: 'recruitFlowSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '招聘流程设置',
                    menuType: 0
                  }
                },
                {
                  id: 'menu-12-9-2',
                  path: '/setting/recruitFlowManage/addFlowSetting',
                  component: 'src/views/setting/recruitFlowManage/recruitFlowSetting/add.vue',
                  name: 'addFlowSetting',
                  always: null,
                  hidden: true,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '新建招聘流程',
                    menuType: 0
                  }
                },
                {
                  id: 'menu-12-9-3',
                  path: '/setting/recruitFlowManage/recruitPhraseSetting',
                  component: 'src/views/setting/recruitFlowManage/recruitPhraseSetting/index.vue',
                  name: 'recruitPhraseSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '招聘阶段设置',
                    menuType: 0
                  }
                },
                {
                  id: 'menu-12-9-4',
                  path: '/setting/recruitFlowManage/recruitStatusSetting',
                  component: 'src/views/setting/recruitFlowManage/recruitStatusSetting/index.vue',
                  name: 'recruitStatusSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '招聘状态设置',
                    menuType: 0
                  }
                },
                {
                  id: 'menu-12-9-5',
                  path: '/setting/recruitFlowManage/phraseFunctionSetting',
                  component: 'src/views/setting/recruitFlowManage/phraseFunctionSetting/index.vue',
                  name: 'phraseFunctionSetting',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '阶段功能设置',
                    menuType: 0
                  }
                },
                {
                  id: 'menu-12-9-6',
                  path: '/setting/recruitFlowManage/evaluationStandards',
                  component: 'src/views/setting/recruitFlowManage/evaluationStandards/index.vue',
                  name: 'evaluationStandards',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '测评标准',
                    menuType: 0
                  }
                },
                {
                  id: 'menu-12-9-6',
                  path: '/setting/recruitFlowManage/trainingStandards',
                  component: 'src/views/setting/recruitFlowManage/trainingStandards/index.vue',
                  name: 'trainingStandards',
                  always: null,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-9',
                  meta: {
                    title: '培训标准',
                    menuType: 0
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '招聘流程管理',
                menuType: 0,
                icon: null
              }
            },
            {
              id: 'menu-12-10',
              path: '/setting/candidatesPool/index',
              component: 'src/views/setting/candidatesPool/index.vue',
              name: 'candidatesPoolSetting',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              meta: {
                activeMenu: null,
                title: '人才库配置',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-11',
              path: '/setting/tagManage/index',
              component: 'src/views/setting/tagManage/index.vue',
              name: 'tagManage',
              always: null,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              meta: {
                activeMenu: null,
                title: '标签管理',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-12',
              path: '/setting/channelManage',
              component: 'src/views/setting/channelManage/index.vue',
              name: 'channelManage',
              always: true,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-12-1',
                  path: '/setting/channelManage/channelManagement',
                  component: 'src/views/setting/channelManage/channelManagement.vue',
                  name: 'channelManagement',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-12',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '渠道来源',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-12-2',
                  path: '/setting/channelManage/accountManagement',
                  component: 'src/views/setting/channelManage/accountManagement.vue',
                  name: 'accountManagement',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-12',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '账号管理',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '渠道管理',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-13',
              path: '/setting/otherSettings',
              component: 'src/views/setting/otherSettings/index.vue',
              name: 'otherSettings',
              always: true,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-13-1',
                  path: '/setting/otherSettings/globalSetting',
                  component: 'src/views/setting/otherSettings/globalSetting.vue',
                  name: 'globalSetting',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-13',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '全局设置',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-13-2',
                  path: '/setting/otherSettings/automaticReminder',
                  component: 'src/views/setting/otherSettings/automaticReminder.vue',
                  name: 'automaticReminder',
                  always: true,
                  hidden: false,
                  redirect: null,
                  parentId: 'menu-12-13',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '自动提醒',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-13-3',
                  path: '/setting/otherSettings/duplicateCheck',
                  component: 'src/views/setting/otherSettings/duplicateCheck.vue',
                  name: 'duplicateCheck',
                  always: true,
                  hidden: false,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: 'menu-12-13',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '查重规则&重复候选人管理',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-13-4',
                  path: '/setting/otherSettings/reasonOption',
                  component: 'src/views/setting/otherSettings/reasonOption.vue',
                  name: 'reasonOption',
                  always: true,
                  hidden: false,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: 'menu-12-13',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '原因选项管理',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '其他设置',
                menuType: 0,
                breadcrumb: true,
                icon: ''
              }
            },
            {
              id: 'menu-12-14',
              path: '/setting/logFeedback',
              component: 'src/views/setting/logFeedback/index.vue',
              name: 'logFeedback',
              always: true,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [
                {
                  id: 'menu-12-14-1',
                  path: '/setting/logFeedback/operationLog',
                  component: 'src/views/setting/logFeedback/operationLog.vue',
                  name: 'operationLog',
                  always: true,
                  hidden: false,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: 'menu-12-14',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '操作日志',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-14-2',
                  path: '/setting/logFeedback/executeTouchLog',
                  component: 'src/views/setting/logFeedback/executeTouchLog.vue',
                  name: 'executeTouchLog',
                  always: true,
                  hidden: false,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: 'menu-12-14',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '执行/触达日志',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                },
                {
                  id: 'menu-12-14-3',
                  path: '/setting/logFeedback/feedback',
                  component: 'src/views/setting/logFeedback/feedback.vue',
                  name: 'feedback',
                  always: true,
                  hidden: false,
                  redirect: null,
                  permissionId: null,
                  permissionCode: null,
                  parentId: 'menu-12-14',
                  children: [],
                  meta: {
                    activeMenu: null,
                    title: '用户反馈',
                    menuType: 0,
                    breadcrumb: true,
                    icon: ''
                  }
                }
              ],
              meta: {
                activeMenu: null,
                title: '企业日志&用户反馈',
                menuType: 0,
                icon: ''
              }
            },
            {
              id: 'menu-12-15',
              path: '/setting/terminationReason',
              component: 'src/views/setting/terminationReason/index.vue',
              name: 'terminationReason',
              always: false,
              hidden: false,
              redirect: null,
              parentId: 'menu-12',
              children: [],
              meta: {
                activeMenu: null,
                title: '终止原因设置',
                menuType: 0,
                icon: ''
              }
            }
          ],
          meta: {
            activeMenu: null,
            title: '设置',
            menuType: 0,
            icon: 'iconfont icon-shezhi18'
          }
        },
        {
          id: 'menu-14',
          path: '/formEdit',
          name: 'formEdit',
          always: null,
          component: 'src/views/formEdit/index.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '表单配置',
            menuType: 1,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-20',
          path: '/setTemplate',
          name: 'setTemplate',
          always: null,
          component: 'src/views/setting/evaluationSystem/setTemplate.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '评价/打分表设置',
            menuType: 1,
            icon: ''
          }
        },
        {
          id: 'menu-99',
          path: '/evaluationTable/edit',
          name: 'evaluationTableEdit',
          always: null,
          component: 'src/views/setting/evaluationTable/edit/index.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '评价/打分表-编辑',
            menuType: 1,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-100',
          path: '/evaluationForm',
          name: 'evaluationFormDetail',
          always: null,
          component: 'src/views/setting/evaluationTable/detail/index.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '评价/打分表-编辑',
            menuType: 1,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-17',
          path: '/recommendStepSearch',
          name: 'recommendStepSearch',
          always: null,
          component: 'src/views/recommendStep/search.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '职位详情',
            menuType: 1,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-18',
          path: '/recommendStepResult',
          name: 'recommendStepResult',
          always: null,
          component: 'src/views/recommendStep/result.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '职位详情',
            menuType: 1,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-15',
          path: '/test',
          name: 'test',
          always: null,
          component: 'src/views/test/index.vue',
          hidden: false,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '测试',
            menuType: 0,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          id: 'menu-16',
          path: '/jobDetail',
          name: 'jobDetail',
          always: null,
          component: 'src/views/jobDetail/index.vue',
          hidden: true,
          redirect: null,
          parentId: 'menu-0',
          children: [],
          meta: {
            activeMenu: null,
            title: '职位详情',
            menuType: 1,
            icon: 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          'id': 'menu-27',
          'path': '/improveResume',
          'name': 'improveResume',
          'always': null,
          'component': 'src/views/improveResume/index.vue',
          'hidden': true,
          'redirect': null,
          'parentId': 'menu-0',
          'children': [],
          'meta': {
            'activeMenu': null,
            'title': '完善简历',
            'menuType': 1,
            'icon': 'iconfont icon-yunyingpingsi18'
          }
        },
        {
          'id': 'menu-19',
          'path': '/assistant',
          'name': 'assistant',
          'always': null,
          'component': 'src/views/assistant/index.vue',
          'hidden': true,
          'redirect': null,
          'parentId': 'menu-0',
          'children': [],
          'meta': {
            'activeMenu': null,
            'title': '简历助手',
            'menuType': 0,
            'icon': 'iconfont icon-yunyingpingsi18'
          }
        }
      ],
      meta: {
        activeMenu: true,
        menuType: 0,
        title: null,
        icon: null
      }
    }
  ], // 菜单列表
  subMenuList: [], // 子菜单列表
  size: Cookies.get('size') || 'medium',
  currentProcess: '',
  currentJob: '',
  lowCodeConfig: {},
  fieldDependencyRules: [],
  needUpdateOfferList: false,
  refreshPage: '', // 跨组件刷新 back_index,
  equityIds: [], // 版本权限id集合
  candidateManagementIsInit: false,
  carrierMode:/Lark/i.test(navigator.userAgent) ? '飞书' : '企微',
  notificationCount: 0 // 通知数量
}
const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  // 设置菜单
  SET_MENU_LIST: (state, vo) => {



    // mock 数据
  //   vo[0]['children'].find(vb=>vb.name === 'setting')['children'].push(    {
  //     "id": "1012099",
  //     "path": "/setting/offerManage",
  //     "component" : "src/views/setting/offerManage/index.vue",
  //     "name": "offerManage",
  //     "always": true,
  //     "hidden": false,
  //     "redirect": "",
  //     "parentId": "1012",
  //     "meta": {
  //         "id": "1012099",
  //         "menuType": 0,
  //         "title": "offer管理",
  //         "icon": null,
  //         "breadcrumb": true
  //     },
  //     "children": [
  //         {
  //             "id": "101209901",
  //             "path": "/setting/offerManage/attachmentTemplate",
  //             "component" : "src/views/setting/offerManage/attachmentTemplate.vue",
  //             "name": "attachmentTemplate",
  //             "always": true,
  //             "hidden": false,
  //             "redirect": "",
  //             "parentId": "1012099",
  //             "meta": {
  //                 "id": "101209901",
  //                 "menuType": 0,
  //                 "title": "offer附件模板设置",
  //                 "icon": null,
  //                 "breadcrumb": true
  //             }
  //         },
  //         {
  //             "id": "101209902",
  //             "path": "/setting/offerManage/createIndex",
  //             "component" : "src/views/setting/offerManage/createIndex.vue",
  //             "name": "createIndex",
  //             "always": true,
  //             "hidden": true,
  //             "redirect": "",
  //             "parentId": "1012099",
  //             "meta": {
  //                 "id": "101209902",
  //                 "menuType": 0,
  //                 "title": "新建Offer模板",
  //                 "icon": null,
  //                 "breadcrumb": true
  //             }
  //         },
  //         {
  //           "id": "101209903",
  //           "path": "/setting/offerManage/offerLoginSetting",
  //           "component" : "src/views/setting/offerManage/offerLoginSetting.vue",
  //           "name": "offerLoginSetting",
  //           "always": true,
  //           "hidden": false,
  //           "redirect": "",
  //           "parentId": "1012099",
  //           "meta": {
  //               "id": "101209903",
  //               "menuType": 0,
  //               "title": "offe页面模板设置",
  //               "icon": null,
  //               "breadcrumb": true
  //           }
  //       },
  //       {
  //         "id": "101209904",
  //         "path": "/setting/offerManage/emailSetting",
  //         "component" : "src/views/setting/offerManage/emailSetting.vue",
  //         "name": "offerLoginSetting",
  //         "always": true,
  //         "hidden": false,
  //         "redirect": "",
  //         "parentId": "1012099",
  //         "meta": {
  //             "id": "101209904",
  //             "menuType": 0,
  //             "title": "邮箱设置",
  //             "icon": null,
  //             "breadcrumb": true
  //         }
  //     },
  //     {
  //       "id": "101209905",
  //       "path": "/setting/offerManage/otherSetting",
  //       "component" : "src/views/setting/offerManage/otherSetting.vue",
  //       "name": "offerLoginSetting",
  //       "always": true,
  //       "hidden": false,
  //       "redirect": "",
  //       "parentId": "1012099",
  //       "meta": {
  //           "id": "101209905",
  //           "menuType": 0,
  //           "title": "其他设置",
  //           "icon": null,
  //           "breadcrumb": true
  //       }
  //   },

  //     ]
  // })
  // 转交路由
  // vo[0].children.forEach(e => {
  //   if (e.code === '1012') {
  //     e.children.push({
  //       "code": "1012016",
  //       "name": "transferResponsibilities",
  //       "parentId": "1012",
  //       "path": "/setting/transferResponsibilities",
  //       "component": "src/views/setting/transferResponsibilities/index.vue",
  //       "redirect": "",
  //       "hidden": false,
  //       "sort": 2,
  //       "always": true,
  //       "type": 1,
  //       "meta": {
  //           "activeMenu": null,
  //           "icon": null,
  //           "menuType": 0,
  //           "title": "系统配置&监控"
  //       },
  //       "children": [
  //         {
  //           "code": "101201601",
  //           "name": "list",
  //           "parentId": "1012016",
  //           "path": "/setting/transferResponsibilities/list",
  //           "component": "src/views/setting/transferResponsibilities/list.vue",
  //           "redirect": "",
  //           "hidden": false,
  //           "sort": 2,
  //           "always": true,
  //           "type": 1,
  //           "meta": {
  //               "activeMenu": null,
  //               "icon": null,
  //               "menuType": 0,
  //               "title": "职责转交"
  //           },
  //           "children": []
  //         },
  //         {
  //           "code": "101201602",
  //           "name": "transferRecord",
  //           "parentId": "1012016",
  //           "path": "/setting/transferResponsibilities/transferRecord",
  //           "component": "src/views/setting/transferResponsibilities/transferRecord.vue",
  //           "redirect": "",
  //           "hidden": false,
  //           "sort": 2,
  //           "always": true,
  //           "type": 1,
  //           "meta": {
  //               "activeMenu": null,
  //               "icon": null,
  //               "menuType": 0,
  //               "title": "招聘业务转交记录"
  //           },
  //           "children": []
  //         }
  //       ]
  //     },)
  //   }
  // })
    // console.log(vo[0], 'vovovovovovovovovovovo1111111')
    state.menuList = vo
  },
  // 点击查询子菜单
  CHANGE_MENU: (state, vo) => {
    state.subMenuList = vo
  },
  SET_PERMISSION: (state, vo) => {
    state.permission = vo
  },
  // 设置菜单
  SET_BUTTON_LIST: (state, vo) => {
    const obj = {}
    const sort = (arr) => {
      arr.forEach((item) => {
        if (item.code) {
          obj[item.code] = true
        }
        if(item.parentId && !obj[item.parentId]){
          obj[item.parentId] = true
        }
        if (item.child && item.child.length) {
          sort(item.child)
        }
      })
    }
    sort(vo || [])
    state.buttonListMap = obj
  },
  SET_REFRESH_PAGE: (state, vo) => {
    state.refreshPage = vo
  },
  // 版本权限id集合
  SET_EQUITY_IDS: (state, vo) => {
    state.equityIds = vo
  },
  SET_candidateManagementIsInit: (state, vo) => {
    state.candidateManagementIsInit = vo
  },
  SET_NOTIFICATION_COUNT: (state, count) => {
    state.notificationCount = count
  },
}
const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  getSubMenuList({ commit }, vo) {
    let subRoutes = []
    vo.routes.forEach(item => {
      if (!item['hidden']) {
        subRoutes = item.children.filter(info => {
          return vo.path.includes(info.path)
        })
        return subRoutes
      }
    })
    if (subRoutes.length > 0) {
      let routers = subRoutes[0].children || []
      commit('CHANGE_MENU', routers)
    }
  },
  // 按钮权限
  queryButtonList({ commit }) {
    return Api.getButtonList({}).then(res => {
      if (res && res.code === '0') {
        commit('SET_BUTTON_LIST', res.data || [])
      } else {
        commit('SET_BUTTON_LIST', [])
      }
    })
  },
  // 获取控制台配置
  getProducts({ commit }) {
    return Api.getProducts({}).then(res => {
      if (res && res.code === 200) {
        commit('SET_PERMISSION', res.data?.products || [])
      } else {
        commit('SET_PERMISSION')
      }
    })
  },
  // 查询菜单
  queryMenuList({ commit, dispatch }) {
    return Api.getMenuList({}).then(res => {
      if (res && res.code === '0') {
        commit('SET_MENU_LIST', res.data || [])
        dispatch('queryButtonList')
      } else {
        commit('SET_MENU_LIST', [])
      }
    })
  },
  // 查询版本权限id集合
  queryEquityIds({ commit }) {
    return Api.getEquity({}).then(res => {
      if (res && res.code === '0') {
        commit('SET_EQUITY_IDS', Object.keys(res.data) || [])
      } else {
        commit('SET_EQUITY_IDS', [])
      }
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
